import React from "react";
import { Link } from "react-router-dom"; 
import SawariLogo from '../../assets/sawari-logo.png';

export default function Footer() {
  const scrollToBooking = () => {
    document.getElementById("find-your-booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-[#002610] !text-gray-400 mt-auto border-t-4 border-emerald-800 font-sans">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        
        {/* Col 1: Brand & UK Registered Office */}
        <div className="flex flex-col space-y-4">
          <Link to="/" className="inline-block self-start">
            <img src={SawariLogo} alt="Sawari Logo" className="h-10 w-auto object-contain brightness-100" />
          </Link>
          <div>
            <h4 className="!text-white font-bold text-xs uppercase tracking-wider mb-2">Registered Office</h4>
            <p className="text-xs !text-gray-400 leading-relaxed">
              <span className="!text-gray-300 font-semibold block mb-1">Sawari Pakistan Limited</span>
              <a 
                href="https://maps.google.com/?q=R1,+179+Bordesley+Green+East,+Birmingham,+West+Midlands,+England,+B9+5SR" 
                target="_blank" 
                rel="noopener noreferrer"
                className="!text-gray-400 hover:!text-white transition block"
              >
                R1, 179 Bordesley Green East,<br />
                Birmingham, West Midlands,<br />
                England, B9 5SR.<br />
                United Kingdom
              </a>
            </p>
          </div>
        </div>

        {/* Col 2: Services Quick Links */}
        <div>
          <h4 className="!text-white font-bold text-sm uppercase tracking-wider mb-4 border-l-2 border-emerald-500 pl-2">Services</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/services" className="!text-gray-400 hover:!text-white transition block">
                Airport Transfers
              </Link>
            </li>
            <li>
              <Link to="/vehicle-rentals" className="!text-gray-400 hover:!text-white transition block">
                Vehicle Rentals
              </Link>
            </li>
            <li>
              <Link to="/tourism-packages" className="!text-gray-400 hover:!text-white transition block">
                Tourism Packages
              </Link>
            </li>
          </ul>
        </div>

        {/* Col 3: Quick Links Section */}
        <div>
          <h4 className="!text-white font-bold text-sm uppercase tracking-wider mb-4 border-l-2 border-emerald-500 pl-2">Quick Links</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/about-us" className="!text-gray-400 hover:!text-white transition block">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact-us" className="!text-gray-400 hover:!text-white transition block">
                Contact Us
              </Link>
            </li>
            <li>
              <button 
                onClick={scrollToBooking} 
                className="!text-gray-400 hover:!text-white transition block text-left bg-transparent border-none p-0 cursor-pointer"
              >
                Track My Booking
              </button>
            </li>
          </ul>
        </div>

        {/* Col 4: 24/7 Support & Legal */}
        <div className="flex flex-col justify-between h-full space-y-6">
          <div>
            <h4 className="!text-white font-bold text-sm uppercase tracking-wider mb-3 border-l-2 border-emerald-500 pl-2">24/7 Support</h4>
            <p className="text-xs mb-2">
              <a href="tel:00923354400044" className="!text-gray-400 hover:!text-white transition inline-flex items-center gap-1.5">
                <svg className="w-4 h-4 text-[#25D366] fill-current" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.713-1.455L0 24zm6.79-4.024l.328.195c1.474.875 3.3.134 4.842.135 5.466 0 9.911-4.444 9.914-9.91 0-2.648-1.031-5.138-2.903-7.01C17.157 1.514 14.669.48 12.013.48c-5.47 0-9.915 4.446-9.919 9.913 0 2.24.588 4.428 1.702 6.326l.214.364-1.126 4.116 4.164-1.092zM17.43 14.54c-.302-.151-1.782-.878-2.053-.977-.272-.1-.469-.151-.667.151-.197.3-.763.953-.934 1.151-.172.197-.343.223-.645.072-1.3-.65-2.235-1.144-3.117-2.655-.23-.396.23-.367.659-1.222.072-.151.036-.284-.018-.396-.054-.112-.469-1.13-.642-1.545-.168-.403-.339-.348-.469-.355-.121-.006-.26-.007-.399-.007-.14 0-.366.052-.556.26-.19.207-.726.71-0.726 1.73s.745 2.01 0.847 2.15c.102.14 1.464 2.235 3.547 3.132.495.213.882.34 1.182.436.498.158.951.135 1.309.082.399-.06 1.783-.728 2.033-1.433.25-.704.25-1.307.175-1.433-.075-.127-.272-.202-.574-.353z"/>
                </svg>
                <span>+92 335 4400044</span>
              </a>
            </p>
            <p className="text-xs">
              <a href="mailto:hello@sawaripakistan.com" className="!text-gray-400 hover:!text-white transition inline-flex items-center gap-1">
                ✉️ <span>hello@sawaripakistan.com</span>
              </a>
            </p>
          </div>
          
          {/* Legal Micro-Links */}
          <div className="pt-2 border-t border-emerald-900/60">
            <div className="flex flex-wrap gap-x-2 gap-y-1 text-[11px]">
              <Link to="/privacy-policy" className="!text-gray-400 hover:!text-white transition">Privacy Policy</Link>
              <span className="text-emerald-900 select-none">•</span>
              <Link to="/terms-and-conditions" className="!text-gray-400 hover:!text-white transition">Terms & Conditions</Link>
              <span className="text-emerald-900 select-none">•</span>
              <Link to="/gdpr-policy" className="!text-gray-400 hover:!text-white transition">GDPR Policy</Link>
            </div>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="w-full bg-[#001a0b] py-4 text-center text-[11px] text-gray-500 border-t border-emerald-950/40">
        <p>© 2026 Sawari Pakistan Limited. All Rights Reserved.</p>
      </div>
    </footer>
  );
}